import ScrollTrigger from '@terwanerik/scrolltrigger'
import $ from 'jquery'

const scrolltrigger = new ScrollTrigger({
    trigger: {
        // If the trigger should just work one time
        once: true,
        offset: {
            // Setting an offset of 0.2 on the viewport means the trigger
            // will be called when the element is 20% in the viewport. So if
            // your screen is 1200x600px, the trigger will be called when the
            // user has scrolled for 120px.
            viewport: {
                y: (trigger, frame, direction) => {
                    // Set to 20% if the element has at least 20% height of the viewport.
                    return $(trigger.element).height() < frame.h * .2 ? 0 : .2
                }
            }
        },
        toggle: {
            // The class(es) that should be toggled
            class: {
                // Either a string, or an array of strings
                in: 'st-visible',
                out: 'st-invisible'
            },
            callback: {
                in: (trigger) => {
                    $(trigger.element).trigger('st-in')
                }
            }
        }
    },
})

scrolltrigger.add('[data-st]')

$('.hentry').each(function() {
    let $article = $(this)
    
    if (!$article.is('[data-st], [data-st-bg]') && !$article.find('[data-st], [data-st-bg]').length) {
        scrolltrigger.add(this)
    } else {
        $article.addClass('not-st-article')
    }
})

scrolltrigger.add('[data-st-bg]', {
    toggle: {
        class: {
            in: 'st-bg-in',
            out: 'st-bg-out',
        },
        callback: {
            in: trigger => {
                return $(trigger.element).find('.inner').imagesLoaded({ background: true })
            }
        }
    }
})

export default scrolltrigger